import React, { useEffect, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import { Link, useNavigate, useParams } from "react-router-dom";
import { ReactComponent as AddUnit } from "../../Assets/Units/AddUnit.svg";
import SelectInput from "../../Global Functions/selectInput";
import TextInput from "../../Global Functions/textInput";
import AddImage from "../../Global Functions/addImage";
import { useDispatch, useSelector } from "react-redux";
import {
  viewCategoryList,
  viewSubCategoryList,
} from "../../Redux/Actions/categoryActions";
import { editUnit, viewUnit } from "../../Redux/Actions/unitsActions";
import ImageShowerModalGlobal from "../../Global Functions/imageShowerModalGlobal";

const EditUnits = () => {
  const { id } = useParams();

  const [addUnitData, setAddUnitData] = useState({
    id: id,
    name: "",
    position: Math.floor(Math.random() * 1000) + 1,
    category: "",
    image: "",
    project_type: "",
  });

  const [selectedCategory, setSelectCategory] = useState("");

  const { categories, subCategories } = useSelector(
    (state) => state.categories || {}
  );

  const { unit } = useSelector((state) => state.units || {});

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleAddChange = (event) => {
    const { name, value } = event.target;
    setAddUnitData((prevData) => ({ ...prevData, [name]: value }));
  };

  useEffect(() => {
    dispatch(viewUnit(id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (unit?.data) {
      setAddUnitData({
        ...unit.data,
        id: id,
        position: Math.floor(Math.random() * 1000) + 1,
      });
    }
  }, [unit, id]);

  const handleImageUpload = async (event) => {
    const uploadedImage = event.target.files[0];
    if (!uploadedImage) return;
    const responseUrl = await AddImage(uploadedImage);
    if (responseUrl) {
      setAddUnitData((prevData) => ({ ...prevData, image: responseUrl }));
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await dispatch(editUnit(addUnitData));
      if (response.statusCode === 200) {
        navigate("/furnishing");
      } else {
        return;
      }
    } catch (error) {
      return;
    }
  };

  useEffect(() => {
    const categoryPayload = {
      page: 1,
      limit: 1000,
    };
    dispatch(viewCategoryList(categoryPayload));
  }, [dispatch]);

  useEffect(() => {
    if (selectedCategory) {
      const subCategoryData = {
        page: 1,
        limit: 1000,
        category_id: selectedCategory,
      };
      dispatch(viewSubCategoryList(subCategoryData));
    }
  }, [selectedCategory, dispatch]);

  return (
    <MainLayout>
      <div className="padding-20 border-24 bg-white grid-span-5" style={{ width: "100%" }}>
        <div className="flex-container flex-justify-between align-center">
          <div className="flex-container">
            <AddUnit></AddUnit>
            <h1>Edit Unit</h1>
          </div>
          <Link to="/furnishing">
            <button className="button-class">View Furnishing List</button>
          </Link>
        </div>
        <form>
          <div className="flex-container flex-justify-between gap-10">
            <div style={{ width: "50%" }}>
              <SelectInput
                label="Select Category"
                disabled
                name="project_type"
                value={addUnitData.project_type}
                placeholder="Select an Option"
                onChange={(event) => {
                  const selection = event.target.value;
                  setSelectCategory(selection);
                  setAddUnitData((prevData) => ({
                    ...prevData,
                    project_type: selection,
                  }));
                }}
                options={
                  Array.isArray(categories?.data)
                    ? categories.data.map((category) => ({
                        label: category.name,
                        value: category._id,
                      }))
                    : []
                }
              ></SelectInput>
            </div>
            <div style={{ width: "50%" }}>
              <SelectInput
                disabled={selectedCategory ? false : true}
                placeholder="Select an Option"
                name="category"
                onChange={handleAddChange}
                label="Select Sub-Category"
                options={
                  Array.isArray(subCategories?.data)
                    ? subCategories.data.map((category) => ({
                        label: category.name,
                        value: category._id,
                      }))
                    : []
                }
              ></SelectInput>
            </div>
          </div>
          <div className="flex-container flex-justify-between gap-10">
            <div style={{ width: "50%" }}>
              <TextInput
                label="Enter Furnishing Type"
                name="name"
                value={addUnitData.name}
                placeholder="Enter Name"
                onChange={handleAddChange}
              ></TextInput>
            </div>
            <div style={{ width: "50%" }}>
              <span className="span-class">Furnishing's Image</span>
              <input
                type="file"
                name="image"
                style={{ display: "none" }}
                onChange={handleImageUpload}
                id="image"
              />
              <label className="label-class-image" htmlFor="image">
                Click to upload image
              </label>
              <ImageShowerModalGlobal
                file={addUnitData.image}
                keyField="image"
                setState={setAddUnitData}
                state={addUnitData}
              ></ImageShowerModalGlobal>
            </div>
          </div>

          <div className="flex-end" style={{ margin: "20px 0px" }}>
            <Link to="/furnishing">
              <button className="button-class-white">Cancel</button>
            </Link>
            <button onClick={handleSubmit} className="button-class">
              Save
            </button>
          </div>
        </form>
      </div>
    </MainLayout>
  );
};

export default EditUnits;
